import { BrowserRouter, HashRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { removeUserSession, getToken } from "./Utils/Common";
import { SnackbarProvider, useSnackbar } from "notistack";
import axios from "axios";
import logger from "./logger";
import React, { useEffect, useState } from "react";
import toastMaker from "./Common/toastmaker";
import AuthService from "./services/AuthService";
import { setupAxiosInterceptors } from "./api/axiosConfig";

import Constants from "./Utils/Constants";
import Drawer from "./Drawer";
import ForgotPassword from "./ForgotPassword";
import Home from "./Home";
import Login from "./Login";
import Quickview from "./Quickview/index1";
import PrivateRoute from "./Utils/PrivateRoute";
import PublicRoute from "./Utils/PublicRoute";
import ResetPassword from "./ResetPassword";
import Signup from "./Signup";
import Unsubscribe from "./Unsubscribe";
import { getHeaders } from "./Utils/Common";
import store from "./Common/storage";
import environment from "./environments";

import "./App.css";

function App(props) {
  const { enqueueSnackbar } = useSnackbar();
  toastMaker.makeToast = enqueueSnackbar;

  const history = useNavigate();

  Constants.navigate = url => history(url, { shallow: true })

  Constants.api = {
    private: () => {
      let headers = getHeaders();
      let ret = {};
      ret.get = (path, params) => axios.get(`${path}?${params}`, headers);
      return ret;
    },
    public: () => {},
    // Thin shim kept for backward compat — delegates to AuthService which
    // handles legacy vs new mode internally via AUTH_MODE environment flag.
    login: (username, password) => AuthService.login(username, password),
  };

  Constants.getApiPathWithConfigId = (path, id = false) => {
    return path.replace('{c_id}', id ? id : store.get('c_id'))
  }

  Constants.getAcUrl = () => {
    return store.get('user').configs[0].host
                .replace('api-us1.com', 'activehosted.com')
  }

  Constants.getAcContactUrl = id => {
    return Constants.getAcUrl() + `/app/contacts/${id}`
  }

  Constants.unsubscribe_link_show = `http://vc1.me/c/{code}`

  Constants.unsubscribe_link = environment.UNSUBSCRIBE_UI.replace('{c_id}', store.get('c_id')).replace('{ac_contact_id}','{{code}}')
  
  Constants.restrictTemplate = [274, 272]
  Constants.restrictCampaign = [274, 272]
  Constants.restrictAutoHist = [274, 272]
  Constants.restrictCampHist = [274, 272]
  Constants.restrict2Way     = []
  Constants.Allow_New_Conversations = true
  Constants.restrictAccounts = [274, 272]
  Constants.restrictSettings = [274, 272]

  logger.log("App.css loaded");

  const [isReady, setIsReady] = useState(false);

  // Register interceptors once on mount; eject on unmount to prevent duplicates.
  useEffect(() => {
    const cleanup = setupAxiosInterceptors(() => {
      removeUserSession();
      window.location.assign(process.env.PUBLIC_URL + "/");
    });
    return cleanup;
  }, []);

  // Gate rendering behind token readiness.
  // On page refresh the access token is gone (memory) but the refresh token
  // persists in localStorage. Exchange it here BEFORE any child component mounts
  // so their initial API calls always carry a valid Authorization header.
  // AuthService.refresh() is deduplicated — even if the 401 interceptor races
  // with this effect, only one HTTP call goes out.
  useEffect(() => {
    const rehydrate = async () => {
      if (!AuthService.isAuthenticated()) {
        await AuthService.refresh().catch(() => {
          // Refresh token expired or absent — user will be redirected to login
          // by the 401 interceptor on the next protected API call.
        });
      }
      setIsReady(true);
    };
    rehydrate();
  }, []);

  if (!isReady) return null;

  return (
    <div className="App">
      {/* <BrowserRouter /*basename={Constants.basepath} > */}
        <div className="content">
          <Routes>
            <Route exact path={Constants.home} element={<PublicRoute><Signup /></PublicRoute>} />
            <Route exact path={Constants.login} element={<PublicRoute><Login /></PublicRoute>} />
            <Route exact path={Constants.quickview} element={<Quickview />} />
            <Route
              exact
              path={Constants.forgotpassword}
              element={<PublicRoute><ForgotPassword /></PublicRoute>}
            />
            <Route
              exact
              path={Constants.resetpassword}
              element={<PublicRoute><ResetPassword /></PublicRoute>}
            />
            <Route exact path={Constants.signup} element={<PublicRoute><Signup /></PublicRoute>} />
            <Route exact path={Constants.unsubscribe} element={<Unsubscribe />} />
            <Route exact path={Constants.unsubscribeshort} element={<Unsubscribe />} />
            <Route
              exact
              path={Constants.unsubscribe}
              element={<Unsubscribe />}
            />
            <Route
              path="/v2/dashboard"
              element={<PrivateRoute><Drawer /></PrivateRoute>}
            />
            <Route
              path={Constants.dashboard}
              element={<PrivateRoute><Drawer /></PrivateRoute>}
            />
            <Route
              path={`${Constants.dashboard}/*`}
              element={<PrivateRoute><Drawer /></PrivateRoute>}
            />
            <Route element={<Home />} />
          </Routes>
        </div>
      {/* </BrowserRouter> */}
    </div>
  );
}

export default function IntegrationNotistack() {
  return (
    <SnackbarProvider maxSnack={3}>
      <App />
    </SnackbarProvider>
  );
}
